import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, TextField } from '@mui/material';
import PeriodSelector from './PeriodSelector';
import Transition from './common/Transition';
import { renewCollaborateurManually, getCollaborateurById } from '../../../services/CollaborateurService';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';


const ProlongStageFormDialog = ({
  open,
  onClose,
  prolongerPeriod,
  setProlongerPeriod,
  prolongerDateDebut,
  getDateFinFromPeriod,
  employeeId,
  employeeContratId,
  snackbarShowMessage,
  setEmployee,
  onBack,
  setReloadNotifications,
  reloadNotifications,
}) => {
  const handleSaveProlongation = async () => {
    try {
      await renewCollaborateurManually(employeeId, {
        periodeContrat: prolongerPeriod,
        dateDebut: prolongerDateDebut.toISOString().substring(0, 10),
        dateFinContrat: getDateFinFromPeriod(prolongerDateDebut, prolongerPeriod)
          .toISOString()
          .substring(0, 10),
        contratId: employeeContratId
      });

      const { data } = await getCollaborateurById(employeeId);
      setEmployee(data);
      setReloadNotifications(!reloadNotifications);

      snackbarShowMessage(<span><CheckCircleIcon style={{ verticalAlign: 'middle', marginRight: 6 }} />Stage prolongé avec succès </span>, 'success');
      onClose();
    } catch (error) {
      snackbarShowMessage(<span style={{ display: 'flex', alignItems: 'center' }}>
        <ErrorOutlineIcon style={{ color: '#d32f2f', marginRight: 6 }} />Erreur: ${error.message} </span>, 'error');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      TransitionComponent={Transition}
      keepMounted
      slotProps={{ paper: {
        sx: {
          borderRadius: 6,
          background: 'rgba(255, 255, 255, 0.75)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          overflow: 'hidden',
        }
      } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          fontFamily: `'Orbitron', 'Segoe UI', sans-serif`,
          fontWeight: 700,
          fontSize: '1.3rem',
          textTransform: 'uppercase',
          letterSpacing: '0.8px',
          color: '#0f172a',
          pt: 4,
        }}
      >
        Prolongation de stage
      </DialogTitle>

      <DialogContent sx={{ px: 4, pt: 2, pb: 3 }}>
        <Box mb={3}>
          <Typography
            variant="subtitle2"
            sx={{
              color: '#0f172a',
              fontWeight: 600,
              fontSize: '1rem',
              textTransform: 'uppercase',
              letterSpacing: '0.8px',
              mb: 1,
            }}
          >
            PÉRIODE DE CONTRAT
          </Typography>
          <PeriodSelector
            selectedPeriod={prolongerPeriod}
            onSelectPeriod={setProlongerPeriod}
          />
        </Box>

        <Box mb={3}>
          <Typography
            variant="subtitle2"
            sx={{
              color: '#0f172a',
              fontWeight: 600,
              fontSize: '1rem',
              textTransform: 'uppercase',
              letterSpacing: '0.8px',
              mb: 1,
            }}
          >
            DATE DE DÉBUT
          </Typography>
          <TextField
            fullWidth
            value={prolongerDateDebut.toISOString().substring(0, 10)}
            disabled
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc',
                borderRadius: '10px',
                paddingX: '10px',
                fontFamily: `'Segoe UI', Roboto, sans-serif`,
                boxShadow: 'inset 0 0 0px 1px #e2e8f0',
              }
            }}
          />
        </Box>

        <Box mb={2}>
          <Typography
            variant="subtitle2"
            sx={{
              color: '#0f172a',
              fontWeight: 600,
              fontSize: '1rem',
              textTransform: 'uppercase',
              letterSpacing: '0.8px',
              mb: 1,
            }}
          >
            DATE DE FIN
          </Typography>
          <TextField
            fullWidth
            value={getDateFinFromPeriod(prolongerDateDebut, prolongerPeriod).toISOString().substring(0, 10)}
            disabled
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc',
                borderRadius: '10px',
                paddingX: '10px',
                fontFamily: `'Segoe UI', Roboto, sans-serif`,
                boxShadow: 'inset 0 0 0px 1px #e2e8f0',
              }
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 2,
          px: 3,
          pb: 4,
          flexWrap: 'wrap'
        }}
      >
        <Button
          variant="outlined"
          onClick={onBack}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '20px',
            px: 3,
            py: 1,
            color: '#c026d3',
            borderColor: '#c026d3',
            '&:hover': {
              background: '#fce7f3',
              borderColor: '#a21caf',
            },
          }}
        >
          Retour
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveProlongation}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '20px',
            px: 3,
            py: 1,
            background: 'linear-gradient(90deg, #3b82f6, #03407b)',
            color: '#fff',
            boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
            '&:hover': {
              background: 'linear-gradient(90deg, #2563eb, #02357a)',
            },
          }}
        >
          Sauvegarder
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProlongStageFormDialog;